module.exports = __webpack_public_path__ + "img/cloud13.0501390b.png";